import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=9cdba7e0&scoped=true&"
import script from "./UploadButton.vue?vue&type=script&lang=js&"
export * from "./UploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdba7e0",
  null
  
)

export default component.exports